import {
  Component, Output, EventEmitter, Input,
} from '@angular/core';
import { CourseFilter } from '../../courseFilter';

@Component({
  selector: 'app-course-requirements-filters',
  templateUrl: './course-requirements-filters.component.html',
  styleUrls: [ './course-requirements-filters.component.scss' ],
})
export class CourseRequirementsFiltersComponent {
  @Input() mainFilter: CourseFilter;
  @Input() requirementList: any;
  @Output() updateMainFilter = new EventEmitter<object>();

  constructor() { }

  checkIncludesRequirement(req: any) {
    return !!this.mainFilter.requirements.find((requirement: any) => requirement.id === req.id);
  }

  updateCheckboxFilter(event: any, requirement: any): void {
    const isChecked = event?.target?.checked;

    if (isChecked) {
      this.mainFilter.requirements.push(requirement);
    } else {
      this.mainFilter.requirements = this.mainFilter.requirements.filter((req: any) => req.id !== requirement.id);
    }
  }

  selectAllRequirementsFilter(event: any): void {
    if (event.target.checked) {
      this.mainFilter.requirements = this.requirementList;
    } else {
      this.mainFilter.requirements = [];
    }
  }

  clearRequirementsFilter(): void {
    this.mainFilter.requirements = [];
  }

  getRequirementHelpText(requirement: any): string {
    // If the requirement has a description, use it
    if (requirement?.description) {
      return requirement.description;
    }

    // If the requirement has additional info, use it
    if (requirement?.additionalInfo) {
      return requirement.additionalInfo;
    }

    // If the requirement has details, use them
    if (requirement?.details) {
      return requirement.details;
    }

    // If the requirement has a type or category, provide context
    if (requirement?.type) {
      return `Show courses that fulfill the ${requirement.type} requirement: ${requirement.requirement}`;
    }

    // If the requirement has hours, mention them
    if (requirement?.hours) {
      return `Show courses that fulfill the ${requirement.requirement} requirement (${requirement.hours} hours)`;
    }

    // Default fallback with requirement name
    return `Show courses that fulfill the ${requirement?.requirement} requirement`;
  }

}
